import React from 'react';
import gallery1 from '../assets/images/gallery/g-1.png';
import gallery2 from '../assets/images/gallery/g-2.png';
import gallery3 from '../assets/images/gallery/g-3.png';
import gallery4 from '../assets/images/gallery/g-4.png';
import gallery5 from '../assets/images/gallery/g-5.png';
import gallery6 from '../assets/images/gallery/g-6.png';
import gallery7 from '../assets/images/gallery/g-7.png';
import gallery8 from '../assets/images/gallery/g-8.png';
import gallery9 from '../assets/images/gallery/g-9.png';
import gallery10 from '../assets/images/gallery/g-10.png';
import gallery11 from '../assets/images/gallery/g-11.png';
import gallery12 from '../assets/images/gallery/g-12.png';
import gallery13 from '../assets/images/gallery/g-13.png';
import gallery14 from '../assets/images/gallery/g-14.png';

const Gallery: React.FC = () => {
  return (
    <div className="bg-[#FFF2DA] min-h-screen">
      {/* Hero Section */}
      <section className="pt-28 md:pt-32 pb-12 md:pb-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="font-teko font-medium uppercase tracking-wide lg:text-6xl font-bold  text-[#0B5C33] leading-[1.1] mb-6 uppercase">
            These are not just pretty photos,
            <br />
            this is a Grill Me Crazy Experience
          </h1>
          <p className="font-inter text-gray-700 text-sm md:text-base max-w-3xl mx-auto leading-relaxed">
            Grill Me Crazy brings together the fire of Indian street flavours and the attitude of Mexican culture into one cinematic dining experience filled with flavour, music, cocktails, and energy.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="px-2 md:px-4 pb-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
            
            {/* Row 1: 2/3 + 1/3 */}
            <div className="md:col-span-2">
              <img
                src={gallery1}
                alt="Fine Dining Setup"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>
            <div className="md:col-span-1">
              <img
                src={gallery2}
                alt="Indian Fry"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>

            {/* Row 2: 1/3 + 2/3 */}
            <div className="md:col-span-1">
              <img
                src={gallery3}
                alt="Bowl Food"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>
            <div className="md:col-span-2">
              <img
                src={gallery4}
                alt="Mexican Art"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>

            {/* Row 3: 1/3 + 1/3 + 1/3 */}
            <div className="md:col-span-1">
              <img
                src={gallery5}
                alt="Indian Thali"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>
            <div className="md:col-span-1">
              <img
                src={gallery6}
                alt="Pizza"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>
            <div className="md:col-span-1">
              <img
                src={gallery7}
                alt="BBQ Food"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>

            {/* Row 4: 1/3 + 1/3 + 1/3 */}
            <div className="md:col-span-1">
              <img
                src={gallery8}
                alt="Plated Dish"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>
            <div className="md:col-span-1">
              <img
                src={gallery9}
                alt="Drink"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>
            <div className="md:col-span-1">
              <img
                src={gallery10}
                alt="Cocktail"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>

            {/* Row 5: 2/3 + 1/3 */}
            <div className="md:col-span-2">
              <img
                src={gallery11}
                alt="Food Plate"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>
            <div className="md:col-span-1">
              <img
                src={gallery12}
                alt="Coffee"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>

            {/* Row 6: 1/3 + 2/3 */}
            <div className="md:col-span-1">
              <img
                src={gallery13}
                alt="Smoothie"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>
            <div className="md:col-span-2">
              <img
                src={gallery14}
                alt="Rice Bowl"
                className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
              />
            </div>
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
